/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line @harmony/stencil/no-component-imports
import { Tooltip } from '@thd-olt-component-react/tooltip';
import classNames from 'classnames';
import { StoreSelectorContent } from '../StoreSelector/StoreSelectorContent';

const textClasses = classNames(
  'sui-flex sui-items-center sui-flex-wrap',
  'sui-text-sm sui-leading-tight sui-tracking-normal sui-normal-case',
  'sui-line-clamp-unset sui-font-normal sui-text-primary'
);

const buttonClasses = 'sui-p-0 sui-m-0 sui-text-left sui-text-sm sui-leading-tight';

export const PickupContent = ({ storeName, stores, hide, isDrawer }) => {
  const [isNearbyStores, setIsNearbyStores] = useState(true);

  const multiStoreSelection = useMemo(() => {
    if (!stores?.nearByStores?.length) {
      return [];
    }
    return [stores.storeId, ...stores.nearByStores.map((store) => store.storeId)];
  }, [stores]);

  const onMultiStoreSelectionChange = ({ stores: multiStoreIds }) => {
    const storeSelection = [...multiStoreIds]
      .filter((selectedStore) => selectedStore.checked)
      .map((selectedStore) => selectedStore?.storeId?.toString());
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('NEARBY_STORES.update', { nearByStores: storeSelection });
  };

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('NEARBY_STORES.update', ({ output }) => {
      setIsNearbyStores(output?.nearByStores?.length > 1);
    });
  }, []);

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('NEARBY_STORES.update',
      { nearByStores: isNearbyStores ? multiStoreSelection : [stores?.storeId] });
  }, [isNearbyStores]);

  if (isDrawer) {
    return (
      <div
        id="fulfillment-pickup-content"
        className={textClasses}
        data-testid="fulfillment-pickup-content"
        style={hide ? { display: 'none' } : undefined}
      >
        <span>In Stock at&nbsp;</span>
        <span className={classNames(buttonClasses)}>{`${storeName} & nearby stores`}</span>
      </div>
    );
  }

  return (
    <Tooltip
      channel="desktop"
      closeButton
      placement="right"
      portal
      content={(
        <StoreSelectorContent
          multiStoreCallback={onMultiStoreSelectionChange}
          multiStoreSelection={multiStoreSelection}
          setNearbyStores={setIsNearbyStores}
        />
      )}
    >
      <div
        id="fulfillment-pickup-content"
        className={textClasses}
        data-testid="fulfillment-pickup-content"
        style={hide ? { display: 'none' } : undefined}
      >
        <span>In Stock at&nbsp;</span>
        <button type="button" className={classNames(buttonClasses, 'sui-underline', 'sui-font-bold')}>
          {`${storeName} & nearby stores`}
        </button>
      </div>
    </Tooltip>
  );
};

export const DeliveryContent = ({ deliveryZip, hide, isDrawer }) => (
  <div
    id="fulfillment-delivery-content"
    className={textClasses}
    data-testid="fulfillment-delivery-content"
    style={hide ? { display: 'none' } : undefined}
  >
    <span>Delivery to&nbsp;</span>
    {isDrawer ? (
      <span className={classNames(buttonClasses)}>{deliveryZip || '...'}</span>
    ) : (
      <button
        type="button"
        className={classNames(buttonClasses, 'sui-underline', 'sui-font-bold')}
        onClick={() => window?.LIFE_CYCLE_EVENT_BUS?.trigger('open_delivery_zip_menu')}
      >
        {deliveryZip || '...'}
      </button>
    )}
  </div>
);

PickupContent.propTypes = {
  storeName: PropTypes.string,
  stores: PropTypes.shape({
    storeId: PropTypes.string,
    storeName: PropTypes.string,
    phone: PropTypes.string,
    address: PropTypes.shape({}),
    nearByStores: PropTypes.arrayOf(PropTypes.shape({
      storeId: PropTypes.string
    }))
  }),
  hide: PropTypes.bool,
  isDrawer: PropTypes.bool
};

PickupContent.defaultProps = {
  storeName: '',
  stores: null,
  hide: false,
  isDrawer: false
};

DeliveryContent.propTypes = {
  deliveryZip: PropTypes.string,
  hide: PropTypes.bool,
  isDrawer: PropTypes.bool
};

DeliveryContent.defaultProps = {
  deliveryZip: '',
  hide: false,
  isDrawer: false
};